'use es6'; // src/index.ts

function compact(object) {
  const clone = Object.assign({}, object);

  for (let key in clone) {
    if (clone[key] === void 0) delete clone[key];
  }

  return clone;
}

function omit(object, keysToOmit = []) {
  const clone = Object.assign({}, object);

  for (const key of keysToOmit) {
    if (key in clone) {
      delete clone[key];
    }
  }

  return clone;
}

function pick(object, keysToPick) {
  const result = {};

  for (const key of keysToPick) {
    if (key in object) {
      result[key] = object[key];
    }
  }

  return result;
}

function split(object, keys) {
  const picked = {};
  const omitted = {};

  for (const [key, value] of Object.entries(object)) {
    if (keys.includes(key)) picked[key] = value;else omitted[key] = value;
  }

  return [picked, omitted];
}

function assignAfter(target, ...sources) {
  if (target == null) {
    throw new TypeError("Cannot convert undefined or null to object");
  }

  const result = Object.assign({}, target);

  for (const nextSource of sources) {
    if (nextSource == null) continue;

    for (const nextKey in nextSource) {
      if (!Object.prototype.hasOwnProperty.call(nextSource, nextKey)) continue;
      if (nextKey in result) delete result[nextKey];
      result[nextKey] = nextSource[nextKey];
    }
  }

  return result;
}

export { assignAfter, compact, omit, pick, split };